(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/animations/composers/slide-composer.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/animations/composers/slide-composer.js');
"use strict";


const slideComposerAsync = (slidesList, slideInTween, slideOutTween, resetTween) => new Promise(resolve => {
  if (!slidesList || slidesList.length < 2) {
    throw new Error('slideList must contain atleast 2 elements');
  }
  const duration = 0.75; 
  const tl = gsap.timeline();
  const slotTime = duration;
  const outEl = slidesList[0][0];
  const inEl = slidesList[1][0];
  tl.add(resetTween(inEl), 0);
  tl.add(slideInTween(inEl, duration), slotTime);
  tl.add(slideOutTween(outEl, duration), slotTime);
  tl.eventCallback('onComplete', () => {
    resolve();
  }).play();
});
setGlobal('svs.components.onboarding.slides.animations.composers.slideComposerAsync', slideComposerAsync);

 })(window);